import Chart from "react-apexcharts";

export interface Props {
  getCashCollectionState3Data: any;
}

export default function DepositTrackingCart({
  getCashCollectionState3Data,
}: Props) {
  const series = [
    {
      name: "Collection",
      data:
        getCashCollectionState3Data?.data?.map(
          (item: any) => item.totalAmount
        ) || [],
    },
    {
      name: "Deposit",
      data:
        getCashCollectionState3Data?.data?.map(
          (item: any) => item.totalReceiving
        ) || [],
    },
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      height: 350,
      stacked: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories:
        getCashCollectionState3Data?.data?.map((item: any) => {
          const date = new Date(item.date);
          const day = date.getDate();
          const month = date.toLocaleString("default", { month: "short" });
          return `${day} ${month}`;
        }) || [],
    },
    yaxis: {
      // min: 0,
      // max: 5000,
      tickAmount: 10,
      labels: {
        formatter: function (val: number) {
          return (
            "৳" + val.toLocaleString("en-IN", { maximumFractionDigits: 0 })
          );
        },
        style: {
          colors: "#4B5563",
          fontSize: "0.875rem",
          fontFamily: "Inter, sans-serif",
          fontWeight: 400,
        },
      },
    },
    colors: ["#2497EB", "#BDE3FE"],
    fill: {
      opacity: 1,
      // colors: ["#2497EB", "#BDE3FE"],
    },
    // tooltip: {
    //   y: {
    //     formatter: function (val: number) {
    //       return "৳" + val;
    //     },
    //   },
    // },
    legend: {
      position: "bottom",
      labels: {
        colors: ["#2497EB", "#BDE3FE"],
        useSeriesColors: true,
      },
    },
  };

  return (
    <>
      <div className="mt-5">
        <Chart options={options} series={series} type="bar" height={350} />
      </div>
    </>
  );
}
